import { render, staticRenderFns } from "./AppGameInstructions.vue?vue&type=template&id=2156630c&scoped=true&"
import script from "./AppGameInstructions.vue?vue&type=script&lang=js&"
export * from "./AppGameInstructions.vue?vue&type=script&lang=js&"
import style0 from "./AppGameInstructions.vue?vue&type=style&index=0&id=2156630c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156630c",
  null
  
)

export default component.exports